<template>
  <div class="pages">
    <headers />

    <div class="main">
      <div class="tabList">
        <ul>
          <li
            :class="checkTab == index?'check':''"
            v-for="(item,index) in projectList"
            :key="index"
            @click="checkTabClick(index)"
          >{{item.name}}</li>
        </ul>
      </div>

      <div class="projectTitle">
        <span>{{projectList[checkTab].name}}</span>
        <span class="overdue">{{projectList[checkTab].restDate}}后过期</span>
      </div>
      <div class="info">
        <p>全部</p>
        <p>
          <span>{{projectList[checkTab].file_total_num}}张</span>
          <span
            v-if="projectList[checkTab].file_total_size < 1024"
          >{{projectList[checkTab].file_total_size}}B</span>
          <span
            v-else-if="1024 <= projectList[checkTab].file_total_size && projectList[checkTab].file_total_size < 1048576"
          >{{(projectList[checkTab].file_total_size / 1024).toFixed(1)}}KB</span>
          <span
            v-else-if="1048576 <= projectList[checkTab].file_total_size && projectList[checkTab].file_total_size < 1073741824"
          >{{(projectList[checkTab].file_total_size/1048576).toFixed(1)}}MB</span>
          <span
            v-else-if="1073741824 <= projectList[checkTab].file_total_size && projectList[checkTab].file_total_size < 1099511627776"
          >{{(projectList[checkTab].file_total_size/1073741824).toFixed(1)}}GB</span>
        </p>
      </div>

      <div class="imgList">
        <div class="imgItem" v-for="(item,index) in projectList[checkTab].file_list" :key="index">
          <div class="quTmd" v-if="item.is_dir == 0" @click="closeSwiper(1,index)">
            <div class="imgView">
              <img
                class="hehe"
                :src="'https://file.zuopin.cloud/' + item.object_key + '?imageMogr2/thumbnail/300x300'"
                alt
              />
              <img
                v-if="item.check == 0"
                src="../../assets/img/imgNoCheck.svg"
                alt
                class="rightTop"
                @click.stop="checkCilck(0,index)"
              />
              <img
                v-if="item.check == 1"
                src="../../assets/img/imgCheck.svg"
                alt
                class="rightTop"
                @click.stop="checkCilck(1,index)"
              />
            </div>
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>

      <div class="saveBtn" @click="saveStatus = true">
        <span v-if="allCheck == 0">保存全部作品</span>
        <span v-else>保存选中作品</span>
      </div>
    </div>

    <div class="maskSwiper" v-if="maskStatus == 1">
      <div class="closeView" @click="closeSwiper(0)">
        <img src="../../assets/img/stepsClose.svg" alt />
      </div>
      <div class="swiperContant">
        <div class="swiperBtn" @click="upNext">
          <img src="../../assets/img/swiperLast.svg" alt />
        </div>

        <div class="swiperImg">
          <p>{{swiperIndex}}/{{ projectList[checkTab].file_list.length}}</p>
          <div class="swiperItem">
            <img
              class="swiperItemImg"
              :src="'https://file.zuopin.cloud/' + projectList[checkTab].file_list[swiperIndex-1].object_key + '?imageMogr2/thumbnail/600x600'"
              alt
            />
            <div
              class="saveImage"
              @click="saveOr(projectList[checkTab].file_list[swiperIndex-1].object_key,projectList[checkTab].file_list[swiperIndex-1].name,projectList[checkTab].file_list[swiperIndex-1].extension)"
            >保存原图</div>
          </div>
          <div class="swiperList" ref="modeilView">
            <div
              class="thumbnail"
              v-for="(item,index) in projectList[checkTab].file_list"
              :key="index"
              :style="index == (swiperIndex-1)?'border:2px solid red':''"
              @click="clikcItemimg(index)"
            >
              <img
                :src="'https://file.zuopin.cloud/' + item.object_key + '?imageMogr2/thumbnail/300x300'"
                alt
                draggable="false"
              />
            </div>
          </div>
        </div>

        <div class="swiperBtn" @click="downNext">
          <img src="../../assets/img/swiperNext.svg" alt />
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <div class="maskPopup" v-if="saveStatus">
      <div class="maskWindow">
        <div class="itemLayout">
          <span>保存选中作品</span>
          <img src="../../assets/img/stepsClose.svg" alt @click="saveStatus = false" />
        </div>
        <div class="itemLayout" @click="downLoadType(0)">
          <p>
            <img v-if="saveType == 0" src="../../assets/img/optionsCheck.svg" alt />
            <img v-else src="../../assets/img/optionsNoCheck.svg" alt />
            保存小图
          </p>
          <!-- <p>17M/约1分钟</p> -->
          <p></p>
        </div>
        <div class="itemLayout" @click="downLoadType(1)">
          <p>
            <img v-if="saveType == 1" src="../../assets/img/optionsCheck.svg" alt />
            <img v-else src="../../assets/img/optionsNoCheck.svg" alt /> 保存原图
          </p>
          <!-- <p>3.2G/约10分钟</p> -->
          <p></p>
        </div>
        <div class="instantly" @click="allCheck == 0?saveAll():savePart()">立即保存</div>
      </div>
    </div>

    <!-- 绑定网盘 -->
    <div class="maskPopup" v-if="false">
      <div class="maskWindow">
        <div class="itemLayout">
          <span></span>
          <img src="../../assets/img/stepsClose.svg" alt />
        </div>
        <div class="textPopup">
          <p>该选项需要授权百度网盘</p>
          <p class="littleText">授权后即可保存原图至网盘</p>
        </div>
        <div class="btnList">
          <div class="close">取消</div>
          <div class="immediately">立即授权</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headers from "../../components/clientHeader";
import { obtain, downUp } from "@/request/api";

import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  name: "clientHome",
  components: { headers },
  data() {
    return {
      maskStatus: 0,
      checkTab: 0,
      allCheck: 0,
      saveType: 0,
      swiperIndex: 1,
      saveStatus: false,
      loading: {},
      projectList: [
        {
          name: "",
          restDate: "",
          file_total_num: 0,
          file_total_size: 0,
          file_list: []
        }
      ],
      allImgArr: []
    };
  },
  mounted() {
    console.log(this._isMobile);
    if (this._isMobile()) {
      this.$router.push({
        path: "/mobileClient", query: this.$route.query
      });
      return;
    }

    this.getProList();
  },
  methods: {
    closeSwiper(status, index) {
      this.maskStatus = status;
      this.swiperIndex = index + 1;
    },
    _isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 头部切换
    checkTabClick(index) {
      this.checkTab = index;
      // 切换的时候，要把图片选中的文件清空
      let { projectList } = this;
      projectList[index].file_list.forEach(element => {
        element.check = 0;
      });
      this.allCheck = 0;
    },
    // 获取列表
    getProList() {
      var that = this;
      var code = this.$route.query.id;
      console.log(code);
      obtain({ code: code }).then(res => {
        let dataDeal = res.data.data;
        dataDeal.forEach(element => {
          // 处理剩余时间
          let startTime = new Date();
          let endTime = new Date(element.expired_at);
          let restDate = endTime - startTime;
          if (restDate / (1000 * 60 * 60 * 24) >= 1) {
            element.restDate =
              (restDate / (1000 * 60 * 60 * 24)).toFixed(0) + "天";
          } else if (restDate / (1000 * 60 * 60) >= 1) {
            element.restDate =
              (restDate / (1000 * 60 * 60)).toFixed(0) + "小时";
          } else {
            element.restDate = (restDate / (1000 * 60)).toFixed(0) + "分";
          }

          // 处理选中
          element.file_list.forEach(item => {
            item.check = 0;
          });

          //处理文件夹
          let list = element.file_list.filter(item => {
            return item.is_dir == 0;
          });

          element.file_list = list;
        });
        console.log(dataDeal);
        this.projectList = dataDeal;
      });
    },

    // 处理图片选中的状态
    checkCilck(status, index) {
      var that = this;
      let { projectList, checkTab } = this;
      projectList[checkTab].file_list.forEach((element, idx) => {
        if (idx == index) {
          if (status == 0) {
            element.check = 1;
          } else {
            element.check = 0;
          }
        }
      });

      let checkImg = projectList[checkTab].file_list.filter(element => {
        if (element.check == 1) {
          return element;
        }
      });

      if (checkImg.length == 0) {
        that.allCheck = 0;
      } else {
        that.allCheck = 1;
      }
    },

    //
    downLoadType(index) {
      this.saveType = index;
    },

    // upNext
    upNext() {
      let { swiperIndex } = this;
      if (swiperIndex != 1) {
        this.swiperIndex = swiperIndex - 1;
      }
      this.mobileView();
    },
    downNext() {
      let { swiperIndex, projectList, checkTab } = this;
      if (projectList[checkTab].file_list.length != swiperIndex) {
        this.swiperIndex = swiperIndex + 1;
      }
      this.mobileView();
    },

    clikcItemimg(index) {
      this.swiperIndex = index + 1;
      this.mobileView();
    },

    // 获取选中的索引，然后让下边自动滚
    mobileView() {
      let { swiperIndex, projectList, checkTab } = this;
      var element = this.$refs.modeilView;
      //
      let average = 680 / 9;
      let allLength = projectList[checkTab].file_list.length;
      if (swiperIndex > 5) {
        element.scrollTo((swiperIndex - 5) * average + 50, 0);
      }
    },

    //loading

    // --------------------------------------------下载----------------------------------------------

    // 保存全部
    saveAll() {
      var that = this;
      let { projectList, checkTab, saveType } = this;
      console.log("1111");
      let allImgArr = [];
      console.log(projectList[checkTab]);
      let arr = projectList[checkTab].file_list;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].is_dir == 0) {
          // 小图
          if (saveType == 0) {
            console.log(saveType, "???? 小图");
            allImgArr.push({
              fileUrl:
                "https://file.zuopin.cloud/" +
                arr[i].object_key +
                "?imageMogr2/thumbnail/600x600",
              renameFileName: arr[i].name + "." + arr[i].extension
            });
          } else {
            console.log(saveType, "???? 原图");
            // 原图
            allImgArr.push({
              fileUrl: "https://file.zuopin.cloud/" + arr[i].object_key,
              renameFileName: arr[i].name + "." + arr[i].extension
            });
          }
        }
      }
      that.filesToRar(allImgArr, projectList[checkTab].name);

      this.loading = this.$loading({
        lock: true,
        text: "正在打包保存中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.saveStatus = false;
    },

    // 保存选中
    savePart() {
      var that = this;
      let { projectList, checkTab, saveType } = this;
      let allImgArr = [];
      let arr = projectList[checkTab].file_list;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].is_dir == 0 && arr[i].check == 1) {
          // 小图
          if (saveType == 0) {
            console.log(saveType, "???? 小图");
            allImgArr.push({
              fileUrl:
                "https://file.zuopin.cloud/" +
                arr[i].object_key +
                "?imageMogr2/thumbnail/300x300",
              renameFileName: arr[i].name + "." + arr[i].extension
            });
          } else {
            console.log(saveType, "???? 原图");
            // 原图
            allImgArr.push({
              fileUrl: "https://file.zuopin.cloud/" + arr[i].object_key,
              renameFileName: arr[i].name + "." + arr[i].extension
            });
          }
        }
      }

      this.loading = this.$loading({
        lock: true,
        text: "正在打包保存中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.saveStatus = false;
      that.filesToRar(allImgArr, projectList[checkTab].name);
    },

    // 保存原图
    saveOr(event, name,extension) {
      let _this = this;
      console.log(event, name);
      let url = "https://file.zuopin.cloud/" + event;
      let names = name + "." + extension
      let allImgArr = [];
      allImgArr.push({
        fileUrl:url,
        renameFileName:names
      });

      this.loading = this.$loading({
        lock: true,
        text: "正在打包保存中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.saveStatus = false;
      this.filesToRar(allImgArr,name);
    },

    filesToRar(arrImages, filename) {
      let _this = this;
      let zip = new JSZip();
      let cache = {};
      let promises = [];
      _this.title = "正在加载压缩文件";

      for (let item of arrImages) {
        const promise = _this.getImgArrayBuffer(item.fileUrl).then(data => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          zip.file(item.renameFileName, data, { binary: true }); // 逐个添加文件
          cache[item.renameFileName] = data;
        });
        promises.push(promise);
      }

      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then(content => {
            _this.title = "正在压缩";
            // 生成二进制流
            FileSaver.saveAs(content, filename); // 利用file-saver保存文件  自定义文件名
            _this.title = "压缩完成";
            _this.loading.close();
            let params = {
              obtain_code: _this.$route.query.id
            };
            downUp().then(res => {
              console.log(res, "下载次数");
            });
          });
        })
        .catch(res => {
           _this.loading.close();
          _this.$message.error("文件压缩失败");
        });
    },
    //获取文件blob
    getImgArrayBuffer(url) {
      let _this = this;
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function() {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 83%;
  min-width: 1000px;
  margin: auto;
  .tabList {
    margin-top: 2.5rem;
    margin-bottom: 1.125rem;
    border: 1px solid rgba(201, 201, 201, 1);
    border-radius: 18px;
    height: 2rem;
    display: inline-block;
    ul {
      list-style: none;
      li {
        float: left;
        border-radius: 18px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        height: 2rem;
        line-height: 2rem;
        padding: 0px 15px;
      }
      .check {
        background: rgba(0, 0, 0, 1);
        color: rgba(255, 255, 255, 1);
      }
    }
  }

  .projectTitle {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    span {
      margin-right: 1.25rem;
    }
    .overdue {
      font-size: 14px;
    }
  }

  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.25rem;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    span {
      margin-left: 15px;
    }
  }

  .imgList {
    // display: flex;
    // flex-wrap: wrap;
    height: 650px;
    margin-top: 1.3125rem;
    overflow-y: scroll;
    .imgItem {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 20px;
      .quTmd {
        width: 7.5rem;
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-right: 16px;

        .imgView {
          width: 7.5rem;
          height: 7.5rem;
          border-radius: 20px;
          position: relative;
          margin-bottom: 0.5rem;
          .hehe {
            width: 7.5rem;
            height: 7.5rem;
            border-radius: 20px;
            object-fit: cover;
          }
          .rightTop {
            position: absolute;
            right: 10px;
            top: 10px;
          }
        }
      }
    }
  }

  .saveBtn {
    width: 10rem;
    height: 2.75rem;
    margin: 0 auto 30px;
    text-align: center;
    line-height: 2.75rem;
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    background: #000;
  }
}

.maskSwiper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(33, 33, 33, 1);
  z-index: 9999999 !important;
  //   cursor: not-allowed;
  .closeView {
    float: right;
    margin-right: 1.8125rem;
    margin-top: 1.8125rem;
  }
  .swiperContant {
    width: calc(100vw - 300px);
    height: 100vh;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .swiperImg {
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      .swiperItem {
        // width: 43.75rem;
        height: 30.6875rem;
        // background: #ffffff;
        margin: 25px 0px 50px;
        position: relative;
        .swiperItemImg {
          width: auto;
          height: 30.6875rem;
        }
        .saveImage {
          position: absolute;
          width: 6.25rem;
          height: 1.875rem;
          border-radius: 20px;
          border: 1px solid #fff;
          background: rgba(0, 0, 0, 0.3);
          text-align: center;
          line-height: 1.875rem;
          bottom: 1rem;
          left: 50%;
          margin-left: -3.125rem;
        }
      }
      .swiperList {
        width: 711px;
        height: 4.4375rem;
        display: -webkit-box;
        overflow-x: scroll;
        .thumbnail {
          margin-right: 8px;
          border-radius: 10px;
          width: 71px;
          height: 71px;
          box-sizing: border-box;
          img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }
        }
      }
    }
  }
}

.maskPopup {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  .maskWindow {
    width: 33.125rem;
    padding: 25px;
    background: #ffffff;
    border-radius: 0.625rem;
    .itemLayout {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
      p {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        img {
          vertical-align: middle;
        }
      }
    }
    .instantly {
      width: 10rem;
      height: 2.75rem;
      border-radius: 22px;
      background: #000;
      margin: auto;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 2.75rem;
    }
  }
}

.textPopup {
  text-align: center;
  p {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
  }
  .littleText {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    margin-top: 11px;
  }
}

.btnList {
  display: flex;
  justify-content: space-around;
  width: 16rem;
  margin: 25px auto 0px;
  div {
    width: 6.875rem;
    height: 2.25rem;
    text-align: center;
    line-height: 2.25rem;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    border-radius: 1.125rem;
  }
  .immediately {
    background: #000000;
    color: #ffffff;
  }
  .close {
    background: rgba(240, 240, 240, 1);
  }
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background-color: rgba(240, 240, 240, 0);
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  box-shadow: inset000pxrgba(240, 240, 240, 0);
  border-radius: 10px;
  background-color: rgba(240, 240, 240, 0);
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0);
  box-shadow: inset000pxrgba(240, 240, 240, 0);
}
</style>